export default __webpack_public_path__ + "images/5190ea6c80dd6ffe398f7f7f971868cc.svg";